import type { Maybe } from '@vrplatform/utils';
import { type Query, useQuery } from '../graphql';
import { useTeam } from '../hooks/team';

export const STORYBOOK_IMPORT_CSV_CONNECTION_QUERY_KEY =
  'import-csv-connection';

export const getImportCsvConnectionQuery = (
  q: Query,
  args: {
    teamId: string;
  }
) =>
  q
    .connection({
      where: {
        tenantId: { _eq: args.teamId },
        status: { _eq: 'active' },
        appId: { _eq: 'csvImport' },
      },
      limit: 1,
    })
    .map<ImportCsvConnection>((connection) => ({
      id: connection.id,
      app: {
        id: connection.appId,
        name: connection.app.name,
        logo: connection.app.iconRound,
      },
      importers: (connection.app.info({
        path: 'importers',
      }) || []) as Importer[],
    }))[0];

export function useImportCsvConnectionQuery() {
  const [{ id: teamId }] = useTeam();

  return useQuery(
    (q, args) => {
      return getImportCsvConnectionQuery(q, args);
    },
    {
      keepPreviousData: true,
      variables: {
        teamId,
      },
      queryKey: ['connections'],
      storybookQueryKey: STORYBOOK_IMPORT_CSV_CONNECTION_QUERY_KEY,
    }
  );
}

type Importer = {
  docsLink: string;
  uniqueRef: string;
  description: string;
  types?: string[];
};

export type ImportCsvConnection = {
  id: string;
  app: {
    id: string;
    name: string;
    logo: Maybe<string>;
  };
  importers: Importer[];
};
